/**
 * Reads the search location's lat/lng fields as bounds.
 *
 * Pure — the location is passed in by the caller.
 *
 * @module searchResultsMap/services/locationBounds
 */

/**
 * @param {object|null} location - Search location from the store.
 * @returns {{ south: number, north: number, west: number, east: number }|null}
 *   The bounds, or null when any edge is missing.
 */
export default function getLocationBounds(location) {
  const south = parseFloat(location?.minimumLatitude);
  const north = parseFloat(location?.maximumLatitude);
  const west = parseFloat(location?.minimumLongitude);
  const east = parseFloat(location?.maximumLongitude);

  return [south, north, west, east].every(Number.isFinite) ? { south, north, west, east } : null;
}
